import { ProjectLocalEvent } from "@/ProjectWorld";
import { inject, injectable } from "tsyringe";
import { TOKEN_IProjectBus, type IProjectBus } from "./ProjectBus";

export const TOKEN_IBroadcastChannel = Symbol('IBroadcastChannel');

export interface IBroadcastChannel {
    /**
     * Notifies other tabs with an array of project events
     * @param events An array of ProjectLocalEvent
     */
    notifyProjectUpdate(projectId: string, events: ProjectLocalEvent[]): void;
}

@injectable()
export class BroadcastChannelService implements IBroadcastChannel {
    private channel: BroadcastChannel;

    constructor(
        @inject(TOKEN_IProjectBus) private readonly projectBus: IProjectBus
    ) {
        this.channel = new BroadcastChannel('project-updates');

        this.channel.onmessage = (event) => {
            const events: ProjectLocalEvent[] = event.data.events;
            const projectId: string = event.data.projectId;
            this.projectBus.otherWindowLocalEvents(projectId, events);
        };
    }

    notifyProjectUpdate(projectId: string, events: ProjectLocalEvent[]) {
        this.channel.postMessage({ projectId, events });
    }
}